import { useState, useEffect } from "react";

import { CacheProvider } from '@emotion/react';

import { SocialShareThree } from "../SocialShareThree/SocialShareThree";
import { getMUICache, getUrl, getEndpoint, getImageId, getImageUrl, getImageSize, setCmsSeoData, fetchAnchorValue } from
    '../../../common/utils';
import './AuthorShowThree.css';
import { URL_PROTOCAL } from '../../Common/Constant';
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';


AuthorShowThree.version = 1000;

AuthorShowThree.lang = 'en';
AuthorShowThree.langs = [
    'en'
];
AuthorShowThree.setLang = (lang: any) => {
    AuthorShowThree.lang = lang;
}

Object.defineProperty(AuthorShowThree, 'name', {
    writable: true,
    value: 'AuthorShowThree'
});

export function AuthorShowThree(props: any) {
    AddImageDimensions();
    SetHighPriorityImages();
    PreloadViewportImages();
    ImageLoader();
    useEffect(() => {
        EagerLoadImages()
    }, []);

    const cache = getMUICache();
    const [authorData, setAuthorData] = useState<any>({});
    const { showDepartment, showViewport, showSocialIcon, anchorLinksValue } = props;
    const endpoint = getEndpoint(props, "MAIN");
    let REQUEST_HOSTNAME: any = null;
    if (props && props.REQUEST_HOSTNAME) {
        REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }

    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, []);

    if (endpoint.isSSR && endpoint.SSRDataObj
        && authorData && Object.keys(authorData).length === 0 && endpoint.SSRDataObj.response.author && endpoint.SSRDataObj.response.author.length > 0) {
        setAuthorData(endpoint.SSRDataObj.response.author[0]);
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
            && endpoint.SSRDataObj.response.author.length > 0) {
            props.exportedKeys.authorid = endpoint.SSRDataObj.response.author[0].id;
        }
        setCmsSeoData(props, endpoint.SSRDataObj.response.author[0], "AuthorShow");
    }

    const fetchComponentData = () => {
        let cardUrl = getUrl(props, 0, false, "MAIN", true);
        ////console.log('cardUrl', cardUrl)

        let headerString = '?' + cardUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(cardUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                if (val?.response?.author && val?.response?.author.length > 0) {
                    setAuthorData(val.response.author[0])
                    if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
                        && val.response.author.length > 0) {
                        props.exportedKeys.authorid = val.response.author[0].id;
                    }
                    setCmsSeoData(props, val.response.author[0], "AuthorShow");
                }
            })
    }




    const getAuthorLink = () => {
        if (typeof authorData?.pubInfo != "undefined" && authorData?.pubInfo != null) {
            const { pubInfo, personalprofile, id } = authorData;
            let url = pubInfo.baseDomain;
            let finalUrl = `${url}${personalprofile.seoname}/author/${id}.html`;
            return finalUrl;
        }
    }

    function isSocialUrlValid(url: string) {
        return url && url.trim() !== "";
    }

    // Determine which social icons to show based on the validity of their URLs
    const showFacebook = isSocialUrlValid(authorData && authorData?.socialmediaprofile?.facebookprofilepage);
    const showTwitter = isSocialUrlValid(authorData && authorData?.socialmediaprofile?.twitterhandle);
    const showLinkedin = isSocialUrlValid(authorData && authorData?.socialmediaprofile?.linkedinurl);
    // const showInstagram = isSocialUrlValid(authorData && authorData?.socialmediaprofile?.instagramurl);
    // const showYoutube = isSocialUrlValid(authorData && authorData?.socialmediaprofile?.youtubeurl);

    return (
        <div className='commoncontainer'>
            <CacheProvider value={cache}>
                <div className='themeThreeAuthorShowWrapper'>
                    <div className='themeThreeAuthorShowImageWrap'>
                        {authorData && Object.keys(authorData).length && getImageSize(authorData.imageid) &&
                            (<picture>
                                <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 264, 198, authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS, '8')} />
                                <source media="(min-width: 320px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 149, 112, authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS, '8')} />

                                {showViewport ? (<img  alt={authorData?.name} title={authorData?.name} loading="lazy"/>)
                                    : (<img  alt={authorData?.name} title={authorData?.name} loading="lazy"/>)}
                            </picture>)
                        }
                    </div>
                    <div className='themeThreeAuthorDetailWrap'>
                        <p className='themeThreeAuthorProfession'>{showDepartment && <span className='authorreport authorreport-desktop'>{authorData && authorData?.professionalprofile &&
                            authorData?.professionalprofile?.authortype}</span>}</p>
                        <p className='themeThreeAuthorName'><a className="author_name" href={getAuthorLink()} target={fetchAnchorValue(anchorLinksValue, getAuthorLink())}>{authorData && authorData?.name}</a></p>
                        <div className='themeThreeAuthorShowSocialWrap'>

                            {showSocialIcon && <SocialShareThree
                                shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL}
                                shareURL_YT={authorData?.socialmediaprofile?.youtubeurl}
                                shareText={authorData?.name}
                                showFacebook={showFacebook}
                                showTwitter={showTwitter}
                                showLinkedin={showLinkedin}
                            // showInstagram={showInstagram}
                            // showYoutube={showYoutube} 
                            />}
                        </div>
                        {authorData && authorData.personalprofile &&
                            <div className="desktopDiscriptonAuthor"><p className='themeThreeAuthorDetails' dangerouslySetInnerHTML={{ __html: authorData.personalprofile.bio }} /></div>}
                    </div>
                </div>
                {authorData && authorData.personalprofile && <div className="mobileDiscriptonAuthor"><p className='themeThreeAuthorDetails' dangerouslySetInnerHTML={{ __html: authorData.personalprofile.bio }} /></div>}
            </CacheProvider>
        </div>
    )
}